import { BaggageKeys, normalizeBaggageValue } from '../baggageKeys';

export interface FullStorySession {
  orgId?: string;
  clientId: string;
  timestampMs?: string;
}

export type FullStorySessionProvider = () => FullStorySession | undefined;

export const FULLSTORY_SESSION_KEYS: readonly BaggageKeys[] = [
  BaggageKeys.RumSessionOrg,
  BaggageKeys.RumSessionId,
  BaggageKeys.RumSessionTs,
];

let sessionProvider: FullStorySessionProvider | undefined;

export function setFullStorySessionProvider(provider: FullStorySessionProvider | undefined): void {
  sessionProvider = provider;
}

export function getFullStorySessionEntries(): Record<string, string> {
  let session: FullStorySession | undefined;
  try {
    session = sessionProvider?.();
  } catch {
    session = undefined;
  }

  const values: Array<[BaggageKeys, string | undefined]> = [
    [BaggageKeys.RumSessionOrg, session?.orgId],
    [BaggageKeys.RumSessionId, session?.clientId],
    [BaggageKeys.RumSessionTs, session?.timestampMs],
  ];

  const entries: Record<string, string> = {};
  for (const [key, value] of values) {
    const normalized = normalizeBaggageValue(value);
    if (normalized) entries[key] = normalized;
  }

  return entries;
}
